const { bookStatusPresentation } = require('./bookStatusPresentation');

function normalizedList(value) {
    return Array.isArray(value) ? value.filter(Boolean) : [];
}

function normalizeBookCardContext(item = {}) {
    const raw = item.card_context && typeof item.card_context === 'object' ? item.card_context : {};
    const shelfStatus = raw.shelf_status || item.status || null;
    const reading = raw.card_reading_context && typeof raw.card_reading_context === 'object' ? raw.card_reading_context : null;
    const actionReading = raw.reading_action_context && typeof raw.reading_action_context === 'object' ? raw.reading_action_context : null;
    const capabilities =
        raw.reading_action_capabilities && typeof raw.reading_action_capabilities === 'object' ? raw.reading_action_capabilities : {};

    const history = raw.history_summary && typeof raw.history_summary === 'object' ? raw.history_summary : null;
    const historyCount = (value) => (Number.isSafeInteger(value) && value >= 0 ? value : 0);
    const latestHistory = history?.latest_history;
    const historySummary = history
        ? {
              completedReadingsCount: historyCount(history.completed_readings_count),
              abandonedReadingsCount: historyCount(history.abandoned_readings_count),
              readingRecordsCount: historyCount(history.reading_records_count),
              archivedSessionsCount: historyCount(history.archived_sessions_count),
              legacyCompletedReadingsCount: historyCount(history.legacy_completed_readings_count),
              latestHistory: latestHistory && ['completed', 'abandoned'].includes(latestHistory.state)
                  ? {
                        state: latestHistory.state,
                        rating: Number.isInteger(latestHistory.rating) ? latestHistory.rating : null,
                        displayDateLabel: typeof latestHistory.display_date_label === 'string' ? latestHistory.display_date_label : null,
                    }
                  : null,
          }
        : null;

    const normalizeReading = (value, idKey = 'id') =>
        value
            ? {
                  ...value,
                  id: value[idKey] ?? value.id ?? null,
                  readingInstanceId: value.reading_instance_id ?? value.id ?? null,
                  lockVersion: value.lock_version ?? null,
                  rating: Number.isInteger(value.rating) ? value.rating : null,
                  languages: normalizedList(value.languages),
                  formats: normalizedList(value.formats),
                  display_date: value.display_date || null,
                  display_date_label: value.display_date_label || null,
                  ratingClear: {
                      allowed: value.rating_clear?.allowed === true,
                      blockedReason: value.rating_clear?.blocked_reason || null,
                  },
              }
            : null;

    return {
        owned: raw.owned === true,
        historySummary,
        readingStatusId: Object.prototype.hasOwnProperty.call(raw, 'reading_status_id') ? raw.reading_status_id : (item.id ?? null),
        readingStatusLockVersion: raw.reading_status_lock_version ?? item.lock_version ?? null,
        shelfStatus,
        statusPresentation: bookStatusPresentation(shelfStatus),
        reading: normalizeReading(reading),
        actionReading: normalizeReading(actionReading, 'reading_instance_id'),
        actionCapabilities: Object.fromEntries(
            ['start', 'mark_read', 'reread', 'pause', 'resume', 'complete', 'abandon', 'start_over', 'retry', 'move_to_want'].map((key) => [
                key,
                capabilities[key] === true,
            ]),
        ),
        pausedResumable: {
            exists: raw.paused_resumable?.exists === true,
            readingInstanceId: raw.paused_resumable?.reading_instance_id ?? null,
        },
        completedReadingsCount: Number(raw.completed_readings_count || 0),
        collectionCount: Number(raw.collection_count || 0),
        publicationAction: raw.publication_action && raw.publication_action.url ? raw.publication_action : null,
        libraryRemoval: {
            quickAllowed: raw.library_removal?.quick_allowed === true,
        },
        quickRemovalAllowed: raw.library_removal?.quick_allowed === true,
        managementUrl: raw.management_url || '',
    };
}

module.exports = { normalizeBookCardContext };
